export const MAINLAND_DIALOG_NAME = {
  C2C_DIALOG_NAME: 'C2C_DIALOG_NAME',
  SCAN_GIFT_DIALOG_NAME: 'SCAN_GIFT_DIALOG_NAME',
  AD_DIALOG_NAME: 'AD_DIALOG_NAME',
};

const MAINLAND_DIALOG_QUEUE = [
  MAINLAND_DIALOG_NAME.C2C_DIALOG_NAME,
  MAINLAND_DIALOG_NAME.SCAN_GIFT_DIALOG_NAME,
  MAINLAND_DIALOG_NAME.AD_DIALOG_NAME,
];

export const DIALOG_QUEUE = [
  ...MAINLAND_DIALOG_QUEUE,
];
